import {API} from '../types';

interface Response {
  success: boolean;
}

export function deleteProfileAPI(id: number): API<Response> {
  return {
    getData: async client => {
      const {data} = await client({
        url: `/profiles/${id}`,
        method: 'DELETE',
      });
      return {data: data};
    },
    getMockData: () => {
      return {success: false};
    },
  };
}
